let isAvailable = false;

try {
    localStorage.setItem('test', '1');
    localStorage.getItem('test');
    isAvailable = true;
} catch (e) {
    isAvailable = false;
}

function isLocalStorageAvailable() {
    return isAvailable;
}

export default isLocalStorageAvailable;
